import { observer } from 'mobx-react-lite'
import { useEffect, useMemo } from 'react'
import { type Campaign, type ICreateCampaignStep } from 'entities/Campaign'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { CampaignStepStore } from './store/CampaignStepStore'
import { CampaignStepContext } from './context/context'
import { CampaignStepUi } from './ui/CampaignStepUi'

export type IStepTableProps = {
  activeStep: ICreateCampaignStep
  campaign: Campaign
}

export const CampaignStep = observer(({ activeStep, campaign }: IStepTableProps) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new CampaignStepStore(campaign, activeStep, entities), [activeStep])

  useEffect(() => {
    return store.dispose
  }, [])
  return (
    <CampaignStepContext.Provider value={store}>
      <CampaignStepUi />
    </CampaignStepContext.Provider>
  )
})
